import '@material/web/icon/icon.js'
import '@operato/input/ox-input-search.js'

import { css, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { openHelp } from '@operato/help'
import { RouteController } from '@operato/shell'
import { isMobileDevice } from '@operato/utils'

@customElement('ox-page-title-bar')
export class PageTitleBar extends LitElement {
  static styles = [
    css`
      :host {
        display: flex;
        align-items: center;
        text-transform: capitalize;

        --help-icon-color: var(--md-sys-color-on-surface);
        --help-icon-hover-color: var(--md-sys-color-on-surface-variant);
        --help-icon-opacity: 0.2;
        --help-icon-size: 20px;

        --md-icon-size: 20px;

        --input-search-padding: var(--spacing-small);
        --input-search-font: normal 14px var(--theme-font);
      }

      [titler] {
        display: flex;
        padding: var(--spacing-small);
        padding-top: var(--spacing-medium);
        font: var(--context-toolbar-title);
        color: var(--title-text-color);
      }

      [titler] > * {
        align-self: center;
      }

      [help] {
        opacity: var(--help-icon-opacity);
        font-size: var(--help-icon-size);
        color: var(--help-icon-color);
      }

      [help]:hover {
        cursor: help;
        opacity: var(--help-icon-hover-opacity);
        color: var(--help-icon-hover-color);
      }

      [search] [help] {
        color: var(--md-sys-color-on-secondary-container);
      }

      [search] {
        display: flex;
        justify-content: space-between;
        align-items: center;

        align-self: center;
        color: var(--md-sys-color-primary);
        background-color: var(--md-sys-color-on-primary);
        border-radius: var(--md-sys-shape-corner-full);
        margin-left: auto;
        padding: 0 var(--spacing-medium);
      }

      [search] > * {
        align-self: center;
      }
    `
  ]

  private _route = new RouteController(this)

  mobile = isMobileDevice()

  render() {
    var { search, filter, title, help } = this._route.context || ({} as any)
    var { value = '', handler: searchHandler, placeholder = '', autofocus = true } = search || ({} as any)
    const { handler: filterHandler } = filter || ({} as any)
    const { icon, text = title } = typeof title === 'object' ? title : ({} as any)
    const searchable = typeof searchHandler == 'function'
    const filterable = typeof filterHandler == 'function'

    if (this.mobile && searchable && title) {
      placeholder ||= title
      title = ''
    }

    return html`
      ${title ? html` <div titler>${icon ? html`<md-icon>${icon}</md-icon>&nbsp;` : html``}${text}</div> ` : html``}
      ${help && title ? html` &nbsp;<md-icon @click=${(e: MouseEvent) => openHelp(help)} help>help</md-icon> ` : html``}
      ${searchable || filterable
        ? html`
            <div search>
              ${searchable
                ? html` <ox-input-search
                    .placeholder=${placeholder}
                    .value=${value || ''}
                    ?autofocus=${autofocus}
                    @change=${(e: Event) => {
                      searchHandler((e.target as any).value)
                    }}
                  ></ox-input-search>`
                : html``}
              ${!title && help && searchable
                ? html`<md-icon @click=${(e: MouseEvent) => openHelp(help)} help>help</md-icon>`
                : html``}
              ${filterable ? html`<md-icon @click=${(e: MouseEvent) => filterHandler()}>unfold_more</md-icon>` : html``}
            </div>
          `
        : html``}
    `
  }
}
